export default "__VITE_ASSET__7CS1XjcT__"